<template>
  <div class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <template v-for="(form_level_info, form_level) in form_levels">
        <service-question-type-form
          :key="form_level"
          v-if="canRenderType(form_level_info.no_sample) && sample_type.id"
          :laboratory="laboratory"
          :sample_type="sample_type"
          :form_level="form_level"
          :heading="form_level_info.title"
          @updateTypeQuestions="handleUpdateTypeQuestions"
        />
      </template>
      <b-button
        @click="submitForm"
        class="mb-4 float-right py-3 px-5"
        variant="success"
      >
        <i class="fal fa-address-book" />
        <span> Save</span>
      </b-button>
    </b-form>
  </div>
</template>

<script>
import ServiceQuestionTypeForm from "@/components/lab/servicequestion/form/ServiceQuestionTypeForm";

export default {
  name: "ServiceQuestionFrom",
  components: {
    ServiceQuestionTypeForm,
  },
  props: {
    laboratory: {
      type: Object,
      default: () => null,
    },
    sample_type: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form_data: {},
      form_levels: {
        project: {
          title: "Project Questions",
          no_sample: true,
        },
        submission: {
          title: "Submission Questions",
          no_sample: false,
        },
        sample: {
          title: "Sample Questions",
          no_sample: false,
        },
      },
    };
  },
  methods: {
    canRenderType(no_sample_bool) {
      return !(no_sample_bool && this.sample_type);
    },
    handleUpdateTypeQuestions({ data, form_level }) {
      this.form_data[form_level] = data;
    },
    submitForm() {
      return this.$emit("submit", this.form_data);
    },
  },
};
</script>
